export enum CampaignTypeEnum {
  requested = 'requested',
  scheduled = 'scheduled',
  active = 'active',
  history = 'history'
}
